/* Soap Supply motion + interaction layer */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Split headlines into words ---------- */
  function split(root) {
    root.querySelectorAll('[data-ss-split]:not([data-ss-split-done])').forEach(function (el) {
      el.setAttribute('data-ss-split-done', '');
      var label = el.textContent.replace(/\s+/g, ' ').trim();
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var parts = child.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'ss-w';
              var wi = document.createElement('span'); wi.className = 'ss-wi'; wi.style.setProperty('--i', i++);
              wi.textContent = p; w.appendChild(wi); frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && !child.classList.contains('ss-w')) {
            walk(child);
          }
        });
      }
      walk(el);
      el.classList.add('ss-split');
      el.setAttribute('aria-label', label);
      el.querySelectorAll('.ss-w').forEach(function (w) { w.setAttribute('aria-hidden', 'true'); });
      if (!el.hasAttribute('data-ss-reveal')) el.setAttribute('data-ss-reveal-split', '');
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-ss-count')) count(e.target);
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function reveal(root) {
    root.querySelectorAll('[data-ss-stagger]').forEach(function (p) {
      Array.prototype.forEach.call(p.children, function (c, idx) {
        if (!c.hasAttribute('data-ss-reveal')) c.setAttribute('data-ss-reveal', p.getAttribute('data-ss-stagger') || '');
        c.style.setProperty('--i', idx);
      });
    });
    root.querySelectorAll('[data-ss-reveal]:not(.is-in), .ss-split:not(.is-in), [data-ss-count]:not(.is-in)').forEach(function (el) {
      if (RM || !io) { el.classList.add('is-in'); if (el.hasAttribute('data-ss-count')) count(el, true); return; }
      io.observe(el);
    });
  }

  /* ---------- Counters ---------- */
  function count(el, instant) {
    var to = parseFloat(el.getAttribute('data-ss-count'));
    if (isNaN(to)) return;
    var dec = (el.getAttribute('data-ss-count').split('.')[1] || '').length;
    if (instant || RM) { el.textContent = to.toFixed(dec); return; }
    var start = null, dur = 1600;
    function tick(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (to * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Hero stage pointer parallax ---------- */
  function stage(root) {
    if (RM || !FINE) return;
    root.querySelectorAll('[data-ss-stage]:not([data-bound])').forEach(function (st) {
      st.setAttribute('data-bound', '');
      var host = st.closest('section') || st;
      var items = st.querySelectorAll('[data-depth]');
      var raf = null, tx = 0, ty = 0;
      host.addEventListener('pointermove', function (ev) {
        var r = host.getBoundingClientRect();
        tx = (ev.clientX - r.left) / r.width - 0.5;
        ty = (ev.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(apply);
      });
      host.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(apply); });
      function apply() {
        raf = null;
        items.forEach(function (it) {
          var d = parseFloat(it.getAttribute('data-depth')) || 1;
          it.style.transform = 'translate3d(' + (tx * d * -28).toFixed(1) + 'px,' + (ty * d * -22).toFixed(1) + 'px,0)';
        });
      }
    });
  }

  /* ---------- Scroll parallax ---------- */
  var plx = [];
  function parallax(root) {
    if (RM) return;
    root.querySelectorAll('[data-ss-parallax]').forEach(function (el) { if (plx.indexOf(el) === -1) plx.push(el); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      document.body.classList.toggle('ss-scrolled', window.scrollY > 10);
      plx.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var sp = parseFloat(el.getAttribute('data-ss-parallax')) || 0.15;
        var c = (r.top + r.height / 2 - vh / 2);
        el.style.transform = 'translate3d(0,' + (c * -sp).toFixed(1) + 'px,0)';
      });
      stories.forEach(updateStory);
    });
  }

  /* ---------- Tilt + magnetic ---------- */
  function tilt(root) {
    if (RM || !FINE) return;
    root.querySelectorAll('[data-ss-tilt]:not([data-bound])').forEach(function (el) {
      el.setAttribute('data-bound', '');
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (y * -6).toFixed(2) + 'deg) rotateY(' + (x * 8).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    root.querySelectorAll('[data-ss-magnetic]:not([data-bound]), .ss-btn:not([data-bound])').forEach(function (el) {
      el.setAttribute('data-bound', '');
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
        el.style.setProperty('--my', (ev.clientY - r.top) + 'px');
        if (el.hasAttribute('data-ss-magnetic')) {
          var x = (ev.clientX - r.left - r.width / 2) * 0.18, y = (ev.clientY - r.top - r.height / 2) * 0.28;
          el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
        }
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Sticky scroll story ---------- */
  var stories = [];
  function story(root) {
    root.querySelectorAll('[data-ss-story]:not([data-bound])').forEach(function (s) {
      s.setAttribute('data-bound', '');
      var steps = Array.prototype.slice.call(s.querySelectorAll('[data-ss-step]'));
      var st = { el: s, steps: steps, orb: s.querySelector('.ss-story__orb'), num: s.querySelector('.ss-story__num span'), bar: s.querySelector('.ss-story__progress'), active: -1 };
      stories.push(st);
      setActive(st, 0);
    });
  }
  function setActive(st, idx) {
    if (st.active === idx) return;
    st.active = idx;
    st.steps.forEach(function (x, i) { x.classList.toggle('is-active', i === idx); });
    var step = st.steps[idx];
    if (!step) return;
    if (st.orb) { st.orb.style.setProperty('--orb-a', step.getAttribute('data-a')); st.orb.style.setProperty('--orb-b', step.getAttribute('data-b')); }
    if (st.num) {
      st.num.classList.add('is-swap');
      setTimeout(function () { st.num.textContent = ('0' + (idx + 1)).slice(-2); st.num.classList.remove('is-swap'); }, 220);
    }
  }
  function updateStory(st) {
    var mid = window.innerHeight * 0.5, best = 0, bestD = Infinity;
    st.steps.forEach(function (x, i) {
      var r = x.getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < bestD) { bestD = d; best = i; }
    });
    setActive(st, best);
    if (st.bar) {
      var list = st.el.querySelector('.ss-story__steps').getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (mid - list.top) / list.height));
      st.bar.style.setProperty('--p', (p * 100).toFixed(1) + '%');
    }
  }

  /* ---------- Copy code ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-ss-copy]');
    if (!b) return;
    var code = b.getAttribute('data-ss-copy');
    var lbl = b.querySelector('[data-ss-copy-label]');
    function done() { if (lbl) { lbl.textContent = 'Copied!'; setTimeout(function () { lbl.textContent = 'Tap to copy'; }, 1800); } }
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- Newsletter popup + teaser tab ---------- */
  function popup() {
    var pop = document.getElementById('SsPopup');
    if (!pop) return;
    var tab = document.getElementById('SsTeaserTab');
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 12;
    var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
    var KEY = 'ss_pop_dismissed', SUB = 'ss_subscribed';
    var success = pop.querySelector('[data-ss-success]');
    var anySuccess = document.querySelector('[data-ss-success]');
    if (anySuccess) store.set(SUB, '1');
    var lastFocus = null;
    function open(force) {
      if (!force && (store.get(SUB) || recentlyDismissed())) return;
      if (pop.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      document.documentElement.style.overflow = 'hidden';
      var f = pop.querySelector('input[type=email]') || pop.querySelector('[data-ss-copy]') || pop.querySelector('.ss-popup__close');
      setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 350);
      if (tab) tab.classList.remove('is-visible');
    }
    function close() {
      pop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      store.set(KEY, String(Date.now()));
      setTimeout(function () { pop.hidden = true; }, 450);
      if (tab && !store.get(SUB)) setTimeout(function () { tab.classList.add('is-visible'); }, 600);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function recentlyDismissed() {
      var t = parseInt(store.get(KEY), 10);
      return t && (Date.now() - t) < days * 864e5;
    }
    pop.querySelectorAll('[data-ss-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') close();
      if (ev.key === 'Tab') {
        var f = pop.querySelectorAll('button, input, a[href]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ss-open-popup], a[href$="#join"]')) { ev.preventDefault(); open(true); }
    });
    if (tab) {
      tab.addEventListener('click', function (ev) {
        if (ev.target.closest('.ss-teaser-tab__x')) { tab.classList.remove('is-visible'); store.set('ss_tab_hidden', '1'); ev.stopPropagation(); return; }
        open(true);
      });
    }
    if (success) { open(true); return; }
    if (window.Shopify && window.Shopify.designMode) return;
    if (store.get(SUB)) return;
    if (recentlyDismissed()) { if (tab && !store.get('ss_tab_hidden')) setTimeout(function () { tab.classList.add('is-visible'); }, 2500); return; }
    var fired = false;
    function fire() { if (fired) return; fired = true; open(false); }
    setTimeout(fire, delay * 1000);
    window.addEventListener('scroll', function sc() {
      var p = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (p > 0.55) { window.removeEventListener('scroll', sc); fire(); }
    }, { passive: true });
    if (FINE) document.addEventListener('mouseout', function (ev) { if (!ev.relatedTarget && ev.clientY < 8) fire(); });
  }

  /* ---------- Quiz ---------- */
  function quiz(root) {
    root.querySelectorAll('[data-ss-quiz]:not([data-bound])').forEach(function (q) {
      q.setAttribute('data-bound', '');
      var steps = Array.prototype.slice.call(q.querySelectorAll('.ss-quiz__step'));
      var bars = q.querySelectorAll('.ss-quiz__progress span');
      var back = q.querySelector('[data-ss-back]');
      var answers = {};
      var cur = 0;
      var data = {};
      try { data = JSON.parse(q.querySelector('[data-ss-quiz-data]').textContent); } catch (e) {}
      function show(i) {
        cur = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) { b.classList.toggle('is-done', k < i || (i === steps.length - 1)); });
        if (back) back.hidden = (i === 0 || i === steps.length - 1);
        var h = steps[i].querySelector('.ss-quiz__q, .ss-result__name');
        if (h && i > 0) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
      q.addEventListener('click', function (ev) {
        var opt = ev.target.closest('.ss-opt');
        if (opt) {
          var step = opt.closest('.ss-quiz__step');
          step.querySelectorAll('.ss-opt').forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
          answers[step.getAttribute('data-key')] = opt.getAttribute('data-value');
          setTimeout(function () {
            if (cur + 1 === steps.length - 1) result();
            show(cur + 1);
          }, 260);
        }
        if (ev.target.closest('[data-ss-back]')) show(Math.max(0, cur - 1));
        if (ev.target.closest('[data-ss-restart]')) { answers = {}; q.querySelectorAll('.ss-opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); }); show(0); }
      });
      function result() {
        var r = (data.results || {})[answers.method] || (data.results || {}).mp || {};
        var level = (data.levels || {})[answers.level] || '';
        var goal = (data.goals || {})[answers.goal] || '';
        var box = steps[steps.length - 1];
        box.querySelector('[data-r-name]').textContent = r.name || 'Your starter setup';
        box.querySelector('[data-r-text]').textContent = [r.text, level, goal].filter(Boolean).join(' ');
        var list = box.querySelector('[data-r-picks]');
        list.innerHTML = '';
        (r.picks || []).forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = p.url; a.innerHTML = '<span class="ss-opt__icon"></span><span></span>';
          a.querySelector('span:last-child').textContent = p.label;
          var ic = q.querySelector('[data-icon-tpl="' + (p.icon || 'soap') + '"]');
          if (ic) a.querySelector('.ss-opt__icon').innerHTML = ic.innerHTML;
          var arrow = q.querySelector('[data-icon-tpl="arrow"]');
          if (arrow) a.insertAdjacentHTML('beforeend', arrow.innerHTML);
          li.appendChild(a); list.appendChild(li);
        });
        var tags = box.querySelector('[data-ss-tags]');
        if (tags) tags.value = ['newsletter', 'quiz', 'method-' + (answers.method || 'na'), 'level-' + (answers.level || 'na'), 'goal-' + (answers.goal || 'na')].join(',');
      }
      var qf = q.querySelector('form');
      if (qf) qf.addEventListener('submit', function () { try { sessionStorage.setItem('ss_quiz', JSON.stringify(answers)); } catch (e) {} });
      if (q.querySelector('[data-ss-success]')) {
        try { answers = JSON.parse(sessionStorage.getItem('ss_quiz')) || {}; } catch (e) {}
        result(); show(steps.length - 1);
      } else show(0);
    });
  }

  /* ---------- Mini calculator teaser ---------- */
  function teaser(root) {
    root.querySelectorAll('[data-ss-teaser]:not([data-bound])').forEach(function (t) {
      t.setAttribute('data-bound', '');
      var range = t.querySelector('input[type=range]');
      var out = t.querySelector('[data-oz]');
      var lye = t.querySelector('[data-lye]'), water = t.querySelector('[data-water]'), bars = t.querySelector('[data-bars]');
      // Classic recipe: 60% olive (0.135), 30% coconut 76 (0.183), 10% castor (0.128) NaOH SAP, 5% superfat, water 2:1 lye
      var sap = 0.6 * 0.135 + 0.3 * 0.183 + 0.1 * 0.128;
      function calc() {
        var oz = parseFloat(range.value);
        var l = oz * sap * 0.95;
        var w = l * 2;
        out.textContent = oz + ' oz';
        lye.textContent = l.toFixed(2) + ' oz';
        water.textContent = w.toFixed(2) + ' oz';
        bars.textContent = Math.floor((oz + l + w) / 4.5);
        range.style.setProperty('--v', ((oz - range.min) / (range.max - range.min) * 100) + '%');
      }
      range.addEventListener('input', calc);
      calc();
    });
  }

  function init(root) {
    root = root || document;
    split(root); reveal(root); stage(root); parallax(root); tilt(root); story(root); quiz(root); teaser(root);
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () { document.documentElement.classList.add('ss-ready'); init(document); popup(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
